import { GridCellProps } from "@progress/kendo-react-grid";
import { CallDetail } from "../../../types/call";
import CallDirection from "../CallDirection";
import { Button } from "@progress/kendo-react-buttons";
import { Tooltip } from "@progress/kendo-react-tooltip";

interface CustomGridCellProps extends GridCellProps {
  dataItem: CallDetail;
}

const CustomGridCellForCallDirection = (props: CustomGridCellProps) => {
  return (
    <td className="text-center">
        <span className="iBtn">          
          <CallDirection callDirection={props.dataItem.callDirection} callType={props.dataItem.callType} callMode={props.dataItem.callMode}/>     
        </span>
    </td>
  );
};

export default CustomGridCellForCallDirection;
